type ScoredItem = {
  combinedScore: number
}

export function partitionRadarReviewItems<T extends ScoredItem>(
  rows: T[],
  relevanceThreshold: number
): { full: T[]; relevant: T[] } {
  return {
    full: rows,
    relevant: rows.filter((row) => row.combinedScore >= relevanceThreshold),
  }
}
